import { svg } from 'lit';

export const caretUpIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 8.29289C12.3166 7.90237 11.6834 7.90237 11.2929 8.29289L5.29292 14.2929C5.00692 14.5789 4.92137 15.009 5.07615 15.3827C5.23093 15.7564 5.59557 16 6.00003 16H18C18.4045 16 18.7691 15.7564 18.9239 15.3827C19.0787 15.009 18.9931 14.5789 18.7071 14.2929L12.7071 8.29289Z" fill="currentColor"/>
  `;
